import { Input } from "@/components/ui/input";

export interface ProductSearchProps {
  value: string;
  onSearchChange: (value: string) => void;
}

export default function ProductSearch({ value, onSearchChange }: ProductSearchProps) {
  return (
    <Input
      type="search"
      value={value}
      onChange={(e) => onSearchChange(e.target.value)}
      placeholder="Buscar produtos..."
      aria-label="Buscar produtos"
      className="max-w-md"
    />
  );
}
